/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Iframe_Remote_Import_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Project import failed. {error}" |
*
* @param {Iframe_Remote_Import_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_import_failed_toast = /** @type {((inputs: Iframe_Remote_Import_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Import_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de l'importation du projet. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Projektimport fehlgeschlagen. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Importazione del progetto non riuscita. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Импорт проекта не удался. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error en la importación del proyecto. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`项目导入失败。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プロジェクトのインポートに失敗しました。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रोजेक्ट आयात विफल रहा। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A importação do projeto falhou. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Project import failed. ${i?.error}`)
});